$(function () {
    // $(document).on('click', '.label', function () {
    //     $('.label-txt', this).css('top', '0');
    // });

    $(document).on('focus', 'input,textarea,select', function () {
        $(this).parents('label:first').find('.label-txt').css('top', '5px');
    });

    $(document).on('focusout', 'input,textarea,select', function () {
        if(!$(this).val()) {
            $(this).parents('label:first').find('.label-txt').removeAttr('style');
        }
    });
    
    document.addEventListener( 'wpcf7mailsent', function() {
        $('.label-txt').removeAttr('style');
    }, false );
});
